import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { useUser } from "../config/userProvider";
import { apiurl } from "../config/config";
import BackHeader from "../components/backHeader";
import Input from "../components/inputContainer";
import { BlackButton } from "../components/buttonContainer";
import Error from "../components/error";
import { IoClose } from "react-icons/io5";

function AddProduct() {
  const { userData } = useUser();
  let vendorObjId = userData?.vendorDetails?.vendorObjId;

  const [formdata, setFormdata] = useState({
    title: "",
    body_html: "",
    product_type: "",
    handle: "",
    status: "active",
    tags: [],
    variants: [
      {
        id: "",
        title: "",
        size: "",
        sku: "",
        price: "",
        image: "",
        barcode: "",
      },
    ],
    images: [],
    image: "",
  });

  console.log("FORMDATA :", formdata);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const token = "your-auth-token";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormdata({ ...formdata, [name]: value });
    setError("");
  };

  const handleVariantChange = (index, field, value) => {
    const updatedVariants = [...formdata.variants];
    updatedVariants[index][field] = value;
    setFormdata({ ...formdata, variants: updatedVariants });
  };

  const addVariant = () => {
    const lastVariant = formdata.variants[formdata.variants.length - 1];

    if (lastVariant && !lastVariant.barcode.trim()) {
      alert(
        "Please fill in the barcode value for the previous variant before adding a new one."
      );
      return;
    }

    setFormdata({
      ...formdata,
      variants: [
        ...formdata.variants,
        {
          barcode: "",
          title: "",
          size: "",
          sku: "",
          price: "",
          image: "",
        },
      ],
    });
  };

  const removeVarientHandler = (barcode) => {
    const updatedVariants = formdata.variants.filter(
      (variant) => variant.barcode !== barcode
    );
    setFormdata({ ...formdata, variants: updatedVariants });
  };

  const handleSubmit = async () => {
    setLoading(true);

    if (
      !formdata?.variants[0]?.barcode ||
      !formdata.title ||
      !formdata.product_type ||
      !formdata.handle ||
      !formdata.status
    ) {
      setError("Please fill in all required fields.");
      setLoading(false);
      return;
    }

    setError("");

    try {
      let data = JSON.stringify({
        barcode: formdata.barcode,
        title: formdata.title,
        body_html: formdata.body_html,
        vendorObjId: vendorObjId,
        product_type: formdata.product_type,
        handle: formdata.handle,
        status: formdata.status,
        tags: formdata.tags,
        variants: formdata.variants,
        images: formdata.images,
        image: formdata.image,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/product/create`,
        headers: {
          "x-api-Key": "2dce270654bbada13964b9d2ff1a9376",
          "x-token": token,
          "Content-Type": "application/json",
        },
        data: data,
      };

      const response = await axios.request(config);
      if (response?.data?.success) {
        setLoading(false);
        navigate("/products");
      } else {
        setLoading(false);
        setError("Failed to add product. Please try again.");
      }
    } catch (err) {
      setError("An error occurred while adding the product. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError("");
      }, 5000);
    }
  }, [error]);

  console.log("formdata", formdata);

  return (
    <Layout>
      <Container>
        <form className="h-full w-full mx-auto">
          <div className="h-[100%] w-[100%] flex flex-col  p-4 overflow-auto">
            <BackHeader
              backButton={true}
              link="/products"
              title=" Add Product"
              rightSide={
                <div className="">
                  <Input.Normal label="Status" isInput={false} />
                  <select
                    name="status"
                    value={formdata.status}
                    className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="active">Active</option>
                    <option value="draft">Draft</option>
                  </select>
                </div>
              }
            />
            <div className="flex-col  flex gap-3 mt-5 md:mt-10  text-sm md:text-base">
              <div className="flex flex-col md:flex-row gap-3 md:gap-4">
                {/* <Input.Normal
                  label="Barcode"
                  name="barcode"
                  value={formdata.barcode}
                  placeholder="Enter Barcode"
                  containerWidth="md:w-[30%]"
                  // className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                  onChange={handleInputChange}
                /> */}

                <Input.Normal
                  label="Title"
                  name="title"
                  value={formdata.title}
                  placeholder="Enter Title"
                  // className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="">
                <Input.TextArea
                  label=" Description (HTML)"
                  name="body_html"
                  value={formdata.body_html}
                  rows="4"
                  placeholder="Enter Description in HTML"
                  // className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                  onChange={handleInputChange}
                />
              </div>

              <Input.Normal
                label="Handle"
                name="handle"
                value={formdata.handle}
                placeholder="Enter Handle"
                // className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                onChange={handleInputChange}
              />

              <FlexCol>
                <div className="md:w-2/6">
                  <Input.Normal label="Product Type" isInput={false} />

                  <select
                    name="product_type"
                    value={formdata.product_type}
                    className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Select Product Type
                    </option>
                    <option value="Electronics">Electronics</option>
                    <option value="Clothing">Clothing</option>
                    <option value="Furniture">Furniture</option>
                  </select>
                </div>

                <div className=" md:w-full">
                  <Input.Normal label="Main Image URL" isInput={false} />
                  <input
                    name="image"
                    value={formdata.image}
                    placeholder="Enter Main Image URL"
                    className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                    onChange={handleInputChange}
                  />
                </div>
              </FlexCol>

              <FlexCol>
                <div className=" md:w-full">
                  <Input.Normal
                    label="Additional Images (comma-separated URLs)"
                    isInput={false}
                  />

                  <input
                    name="images"
                    value={formdata.images.join(",")}
                    placeholder="Enter Additional Image URLs"
                    className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                    onChange={(e) =>
                      setFormdata({
                        ...formdata,
                        images: e.target.value.split(","),
                      })
                    }
                  />
                </div>

                <div className="">
                  <Input.Normal
                    label="Tags (comma-separated)"
                    isInput={false}
                  />
                  <input
                    name="tags"
                    value={formdata.tags.join(",")}
                    placeholder="Enter Tags"
                    className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                    onChange={(e) =>
                      setFormdata({
                        ...formdata,
                        tags: e.target.value.split(","),
                      })
                    }
                  />
                </div>
              </FlexCol>
              <div className="">
                <Input.Normal label="Variants" isInput={false} />
                {formdata.variants.map((variant, index) => (
                  <div
                    key={index}
                    className="border border-slate-300 p-3 mb-2 rounded-lg relative group"
                  >
                    <button
                      className="absolute -top-1 -right-1 bg-zinc-950 text-white rounded-full p-1 group-hover:block hidden "
                      onClick={() => removeVarientHandler(variant?.barcode)}
                    >
                      <IoClose />
                    </button>
                    <input
                      placeholder="barcode"
                      value={variant.barcode}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Remove any digits from the input
                        const filteredValue = value.replace(/\D/g, "");
                        handleVariantChange(index, "barcode", filteredValue);
                      }}
                      className="w-full border border-slate-300 px-3 py-2 mb-2 rounded-lg focus:outline-none"
                    />
                    <input
                      placeholder="Title"
                      value={variant.title}
                      onChange={(e) =>
                        handleVariantChange(index, "title", e.target.value)
                      }
                      className="w-full border border-slate-300 px-3 py-2 mb-2 rounded-lg focus:outline-none"
                    />
                    <input
                      placeholder="Size"
                      value={variant.size}
                      onChange={(e) =>
                        handleVariantChange(index, "size", e.target.value)
                      }
                      className="w-full border border-slate-300 px-3 py-2 mb-2 rounded-lg focus:outline-none"
                    />
                    <input
                      placeholder="SKU"
                      value={variant.sku}
                      onChange={(e) =>
                        handleVariantChange(index, "sku", e.target.value)
                      }
                      className="w-full border border-slate-300 px-3 py-2 mb-2 rounded-lg focus:outline-none"
                    />
                    <input
                      placeholder="Price"
                      value={variant.price}
                      onChange={(e) =>
                        handleVariantChange(index, "price", e.target.value)
                      }
                      className="w-full border border-slate-300 px-3 py-2 mb-2 rounded-lg focus:outline-none"
                    />
                    <input
                      placeholder="Image URL"
                      value={variant.image}
                      onChange={(e) =>
                        handleVariantChange(index, "image", e.target.value)
                      }
                      className="w-full border border-slate-300 px-3 py-2 rounded-lg focus:outline-none"
                    />
                  </div>
                ))}

                <BlackButton handleSubmit={addVariant} title="Add Variant" />
                {/* <button
                  onClick={addVariant}
                  className="bg-slate-400 text-white px-4 py-1 rounded-md mt-2"
                >
                  Add Variant
                </button> */}
              </div>

              <div className="text-center">
                <BlackButton
                  // handleSubmit={handleSubmit}
                  disabled={loading}
                  loading={loading}
                  title="Add Products"
                  loadingTitle="Adding..."
                  handleSubmit={handleSubmit}
                />
              </div>
            </div>
          </div>
        </form>
        {error && (
          <Error
            err={error}
            className="absolute top-2 left-1/2 -translate-x-1/2"
          />
        )}
        {/* {error &&   <Error err={error} /> <p className="text-red-500 text-sm mb-4">{error}</p>} */}
      </Container>
    </Layout>
  );
}

export default AddProduct;

const FlexCol = ({ children }) => (
  <div className="flex-col md:flex-row flex gap-3 w-full">{children}</div>
);
